import AsyncStorage from '@react-native-async-storage/async-storage'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

const ONBOARDING_COMPLETED_KEY = 'onboarding_completed'

type OnboardingState = {
  initialized: boolean
  completed: boolean
}

const initialState: OnboardingState = {
  initialized: false,
  completed: false,
}

export const initOnboardingThunk = createAsyncThunk<boolean>('onboarding/init', async () => {
  const value = await AsyncStorage.getItem(ONBOARDING_COMPLETED_KEY)
  return value === 'true'
})

export const completeOnboardingThunk = createAsyncThunk<void>('onboarding/complete', async () => {
  await AsyncStorage.setItem(ONBOARDING_COMPLETED_KEY, 'true')
})

export const onboardingSlice = createSlice({
  name: 'onboarding',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(initOnboardingThunk.fulfilled, (state, action) => {
        state.initialized = true
        state.completed = action.payload
      })
      .addCase(completeOnboardingThunk.fulfilled, state => {
        state.completed = true
      })
  },
})

export default onboardingSlice.reducer
